import { render, staticRenderFns } from "./exchange_records.vue?vue&type=template&id=03331284&scoped=true"
import script from "./exchange_records.vue?vue&type=script&lang=js"
export * from "./exchange_records.vue?vue&type=script&lang=js"
import style0 from "./exchange_records.vue?vue&type=style&index=0&id=03331284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03331284",
  null
  
)

export default component.exports